import { stringifyDocValue } from "../../lib/parse.js";
import _sfc_main$1 from "./code_editor_indent.vue.js";
import { Fragment, computed, createCommentVNode, createElementBlock, createElementVNode, createVNode, normalizeClass, openBlock, renderList, toDisplayString, withCtx } from "vue";
//#region src/components/code_editor/code_editor_tag_attributes.vue
var _hoisted_1 = {
	key: 0,
	class: "dtc-code-editor__margin"
};
var _hoisted_2 = { key: 0 };
var _hoisted_3 = { class: "dtc-scheme__class" };
var _hoisted_4 = { key: 1 };
var _sfc_main = /* @__PURE__ */ Object.assign({ name: "DtcCodeEditorTagAttributes" }, {
	props: {
		infoBindings: {
			type: Array,
			required: true
		},
		optionBindings: {
			type: Object,
			required: true
		},
		verbose: {
			type: Boolean,
			default: false
		},
		disabledMembers: {
			type: Set,
			default: () => /* @__PURE__ */ new Set()
		}
	},
	setup(__props) {
		const props = __props;
		/**
		* Merges binding info with the actual binding values to conditionally
		* display them in the tag.
		*
		* @type {ComputedRef<object>}
		*/
		const bindingMap = computed(() => {
			return Object.entries(props.optionBindings).map(([bindingName, value]) => {
				return [bindingName, {
					...props.infoBindings.find((infoBinding) => infoBinding.name === bindingName),
					value
				}];
			}).filter(([name, member]) => isMemberVisible(name, member));
		});
		/**
		* Determines if the member is visible.
		* Compares the current value of the member to the default value.
		* All members are considered visible if the verbose setting is on.
		*
		* @param name - The member name.
		* @param member - The member info.
		* @returns {boolean} If the member is visible.
		*/
		function isMemberVisible(name, member) {
			if (props.disabledMembers.has(name)) return false;
			if (member.value === null || typeof member.value === "number" && isNaN(member.value)) return false;
			if (props.verbose) return true;
			return JSON.stringify(member.defaultValue) !== JSON.stringify(member.value);
		}
		/**
		* If the value is boolean it should only show the member and not the value.
		*
		* @param value - The member value.
		* @returns {boolean} - If the member should be displayed using short syntax.
		*/
		function useShortSyntax(value) {
			return value === true;
		}
		/**
		* If the value is not a string it should use the ':' operator
		* to indicate the true value is being passed in.
		*
		* @param value - The member value.
		* @returns {boolean} If the member should be displayed using the bind operator.
		*/
		function useBindOperator(value) {
			return !useShortSyntax(value) && typeof value !== "string";
		}
		function stringifyValue(value) {
			if (!value) return `${value}`;
			return useBindOperator(value) ? stringifyDocValue(value) : value.toString();
		}
		const isEmpty = computed(() => {
			return bindingMap.value.length <= 0;
		});
		return (_ctx, _cache) => {
			return !isEmpty.value ? (openBlock(), createElementBlock("div", _hoisted_1, [createVNode(_sfc_main$1, null, {
				default: withCtx(() => [createElementVNode("div", null, [(openBlock(true), createElementBlock(Fragment, null, renderList(bindingMap.value, ([name, { value, label }]) => {
					return openBlock(), createElementBlock("div", { key: name }, [
						useBindOperator(value) ? (openBlock(), createElementBlock("span", _hoisted_2, ":")) : createCommentVNode("", true),
						createElementVNode("span", _hoisted_3, toDisplayString(label), 1),
						!useShortSyntax(value) ? (openBlock(), createElementBlock("span", _hoisted_4, [
							_cache[0] || (_cache[0] = createElementVNode("span", null, "=", -1)),
							_cache[1] || (_cache[1] = createElementVNode("span", { class: "dtc-scheme__string" }, "\"", -1)),
							createElementVNode("span", { class: normalizeClass({
								"dtc-scheme__string": !useBindOperator(value),
								"dtc-scheme__value": useBindOperator(value)
							}) }, toDisplayString(stringifyValue(value)), 3),
							_cache[2] || (_cache[2] = createElementVNode("span", { class: "dtc-scheme__string" }, "\"", -1))
						])) : createCommentVNode("", true)
					]);
				}), 128))])]),
				_: 1
			})])) : createCommentVNode("", true);
		};
	}
});
//#endregion
export { _sfc_main as default };

//# sourceMappingURL=code_editor_tag_attributes.vue.js.map